import { CustomerTypeCd } from '@xpo-ltl/sdk-common';
import { Customer } from '../../model/customer';
import { CustomerGroup } from '../../model/customer-group';
import { CustomerGroup as CustGroup } from '@xpo-ltl/sdk-customer';
import { AcctPartyRole } from '../../enums/customer-type.enum';
import { DateTimeHelper } from '../../utils/date-time-helper';
import { CustomerSearchMatchRecord } from '../../model/customer-search';

export class CustomerSearchTransformer {
  public static toCustomer(customerSearchRecord: CustomerSearchMatchRecord, restricted: boolean = false): Customer {
    const customerBasic = <Customer>{};
    customerBasic.customerInstId = customerSearchRecord.customerNbr;
    customerBasic.customerMadCd = customerSearchRecord.madCd;
    if (customerSearchRecord.customerTypeCd === AcctPartyRole.PickupDelivery) {
      customerBasic.customerType = CustomerTypeCd.PICKUP_DELIVERY;
    } else if (customerSearchRecord.customerTypeCd === AcctPartyRole.BillTo) {
      customerBasic.customerType = CustomerTypeCd.BILL_TO;
    }
    customerBasic.name1 = customerSearchRecord.name1;
    customerBasic.name2 = customerSearchRecord.name2;
    customerBasic.address = customerSearchRecord.addressLine1;
    customerBasic.state = customerSearchRecord.stateCd;
    customerBasic.city = customerSearchRecord.cityName;
    customerBasic.zip = customerSearchRecord.postalCd;
    customerBasic.zip4 = customerSearchRecord.usZip4;
    customerBasic.isRestricted = restricted;
    return customerBasic;
  }

  public static toCustomerType(customerTypeCd: CustomerTypeCd): string {
    if (customerTypeCd === CustomerTypeCd.PICKUP_DELIVERY) {
      return AcctPartyRole.PickupDelivery;
    } else if (customerTypeCd === CustomerTypeCd.BILL_TO) {
      return AcctPartyRole.BillTo;
    }
  }

  public static toCustomerGroup(custGroup: CustGroup): CustomerGroup {
    const customerGroup = <CustomerGroup>{};

    if (custGroup) {
      customerGroup.custGroupInstId = custGroup.custGroupInstId;
      customerGroup.effDate = DateTimeHelper.conditionDateFromServer(new Date(custGroup.effDate));
      customerGroup.expiryDate = DateTimeHelper.conditionDateFromServer(new Date(custGroup.expiryDate));
      customerGroup.groupMadCd = custGroup.groupMadCd;
      customerGroup.groupName = custGroup.groupName;
      customerGroup.groupType = custGroup.groupType; // There is no enum for groupType
    }

    return customerGroup;
  }
}
